import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { Component } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { CustomizerSettingsService } from 'src/app/components/customizer-settings/customizer-settings.service';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { ApiResponse } from 'src/app/core/interfaces/api-response/ApiResponse.interface';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
    public forgotPasswordForm!: FormGroup;
    public AuthenticationRoutes = urlRoutes;
    public isMailSent = false;
    showSuccess:boolean = false;
    mailData: any;
    constructor(
        public themeService: CustomizerSettingsService,
        private authenticationService: AuthenticationService,
        private toasterService: ToasterService,
        private loaderService: LoaderService,
        public readonly formBuilder: FormBuilder
    ) {}

    ngOnInit(): void {
        this.createLoginForm();
    }

    public get f() {
        return this.forgotPasswordForm.controls;
    }

    private createLoginForm(): void {
        this.forgotPasswordForm = this.formBuilder.group({
            email: [null, [Validators.required, Validators.email]],
        });
    }

    public showFieldError(field: AbstractControl): boolean {
        return field.invalid && (field.dirty || field.touched);
    }

    public toggleTheme(): void {
        this.themeService.toggleTheme();
    }

    public toggleCardBorderTheme(): void {
        this.themeService.toggleCardBorderTheme();
    }

    public toggleCardBorderRadiusTheme(): void {
        this.themeService.toggleCardBorderRadiusTheme();
    }

    public toggleRTLEnabledTheme(): void {
        this.themeService.toggleRTLEnabledTheme();
    }

    public onSubmit(): void {
        if (this.forgotPasswordForm.invalid) {
            return;
        }
        this.loaderService.showLoader();
        const formValues = this.forgotPasswordForm.getRawValue();
        const payload = {
            email: formValues?.email,
        };
        this.authenticationService.forgotPassowrd(payload).subscribe({
            next:
                (response: ApiResponse<{
                    message: string;
                    status: boolean;
                }>) => {
                    this.loaderService.hideLoader();
                    // this.toasterService.showSuccess(
                    //     response.data?.message,
                    //     response.message
                    // );

                    this.toasterService.showSuccess(
                        "An email has been sent!",
                        ""
                    );
                    this.showSuccess = true;
                    this.mailData = response?.data;
                    if (response.data?.status) {
                        this.isMailSent = true;
                        this.forgotPasswordForm.reset();
                        this.showSuccess = true;
                    }
                },
            error: (err: any) => {
                if (err?.status === 400) {
                    this.loaderService.hideLoader();
                    this.toasterService.showError(
                        "Sorry! Couldn't found the mail!",
                        ""
                    );
                }
            }
        },
        );
    }
}
